/*
  Editorial "Shop the edit" carousel.

  A single horizontal, scroll-snap row (no library). Arrows scroll by one
  visible width, disable at each end, and hide entirely when everything fits.
  A ResizeObserver keeps the arrow state and the arrows' vertical centre (aligned
  to the product images) correct as the viewport changes. Scoped per section,
  re-initialises on shopify:section:load, and never initialises the same track
  twice.
*/
(function () {
  function initSection(section) {
    if (!section || section.dataset.carouselReady === '1') return;
    var track = section.querySelector('[data-carousel-track]');
    if (!track) return;
    section.dataset.carouselReady = '1';

    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var fits = maxScroll <= 1;

      // Hide both arrows when every product already fits in view.
      section.classList.toggle('article-collection--static', fits);

      // Vertically centre the arrows on the product image, not the whole card.
      var media = track.querySelector('.editorial-card__media');
      if (media) {
        section.style.setProperty(
          '--carousel-media-center',
          media.getBoundingClientRect().height / 2 + 'px'
        );
      }

      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      });
    }

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(update);
    });

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        update();
      }).observe(track);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(update);
    }
    window.addEventListener('load', update);

    update();
  }

  function scan() {
    var sections = document.querySelectorAll('[data-collection-carousel]');
    Array.prototype.forEach.call(sections, initSection);
  }

  // Register document-level listeners once; later instances (theme-editor
  // reloads) just trigger another scan of the fresh DOM.
  if (window.__wallaceCollectionCarousel) {
    window.__wallaceCollectionCarousel.scan();
  } else {
    window.__wallaceCollectionCarousel = { scan: scan };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }
    window.addEventListener('load', scan);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scan);
    }
    document.addEventListener('shopify:section:load', scan);
  }
})();
